import React, { useEffect, useState } from 'react'
import AnOtpInput from '../../components/input_utils/AnOtpInput'
import { Button } from '../../components/cta_utils/AnButton'
import { AnInputCheckBox } from '../../components/input_utils/AnInputCheckBox'
import { resend_otp, send_otp_verification } from './api'
import { FlashMessages } from '../../components/cta_utils/FlashMessages'

export const DEFAULT_OTP_LENGTH = 6
const OtpVerification = ({
    user_info = {email: ''},
    onLoginSuccess,
    ...props
}) => {  
  const [verifyState, setVerifyState] = useState({
    otp: new Array(DEFAULT_OTP_LENGTH).fill(""),
    isLoading: {verifyLoader: false},
    trustDevice: false,
    errors: {},
    successMessages: {}
  })
  const {otp, isLoading, trustDevice, errors, successMessages} = verifyState
  const onSubmit = () => {
    setVerifyState({...verifyState, isLoading: {verifyLoader: true}})
    let data_params = {trust_device: trustDevice, email: user_info.email, otp: otp.join("")}
    send_otp_verification(data_params).then((response)=>{
        onLoginSuccess(response.data)
    }).catch((error) => {
        let otp_errors= error.response.data.server_message || {}
        let otp_limit_error = otp_errors?.otp_attemps_exceed || otp_errors?.wrong_otp_attemps_exceed
        let success_messages = {}
        if(otp_errors?.otp_invalid)
            success_messages = {
                messageTheme: 'error',
                message: otp_errors?.otp_invalid,
                duration: 3000,
            }
        if(otp_limit_error)
            success_messages = {
                messageTheme: 'warning',
                message: otp_limit_error,
                duration: 3000,
            }
        setVerifyState({
            ...verifyState, 
            errors: {...otp_errors},
            isLoading: {verifyLoader: false},
            successMessages: success_messages
        })
    })
  }
  const onResend = () => {
    let data_params = {trust_device: trustDevice, email: user_info.email, otp: otp}
    resend_otp(data_params).then((response)=>{
        
    }).catch((error) => {
        let otp_errors= error.response.data.server_message || {}
        setVerifyState({
            ...verifyState, 
            errors: {...otp_errors},
            successMessages: {
                messageTheme: 'error',
                message: otp_errors?.otp_attemps_exceed,
                duration: 3000,
            }
        })
    })
  }
  return (
    <div>
    <div className='login_component_container' style={{textAlign: 'center'}}>
        <div className="text_body_big_light_semi_bold">
            Please enter the verification code sent to
        </div>
        <div className='text_body_big_light_bold'>{user_info.email}</div>
        <div style={{margin: '26px auto 4px'}}>
            <AnOtpInput otp={otp} setVerifyState={(payload) => setVerifyState(prevState => ({...prevState, ...payload}))} onSubmit={onSubmit} errors={errors}></AnOtpInput>
        </div>
        <div className='text_body_light'>Didn't receive the code?  <span className='text_link' onClick={() => onResend()}>Resend</span></div>
        <div className='btn_login' style={{marginTop: 32}}>
            <Button buttonSize="Big" onClick={onSubmit} isLoading={isLoading?.verifyLoader} buttonStyle={{width: '100%'}}>
                Verify
            </Button>
        </div>
        <div className='default_flex_container' style={{justifyContent: 'center'}}>
            <AnInputCheckBox
                label="Trust This Device for 30 days"
                isChecked={trustDevice}
                style={{ marginTop: 12 }}

            >
                <input
                    type="checkbox"
                    checked={trustDevice}
                    onChange={() => setVerifyState({...verifyState, trustDevice: !trustDevice })}>
                </input>
            </AnInputCheckBox>
        </div>
        </div>
    {successMessages.message && (
                <FlashMessages
                    messageTheme={successMessages.messageTheme}
                    duration={successMessages.duration} 
                    closeCallback={() =>
                        setVerifyState(prevState => ({
                            ...prevState,
                            successMessages: {}
                        }))
                    }
                >
                    {successMessages.message}
                </FlashMessages>
            )}
    </div>
  )
}

export default OtpVerification